import { render } from "./SitePlanArchiveStandardSearch.vue?vue&type=template&id=f95e6ff0"
import script from "./SitePlanArchiveStandardSearch.vue?vue&type=script&lang=js"
export * from "./SitePlanArchiveStandardSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__